import React from 'react';
import PropTypes from 'prop-types';

/**
 * ModalCardTitle - A wrapper that renders a standard HTML heading with Bulma class names
 * 
 * This component accepts the same props as Bloomer ModalCardTitle for easy migration
 */
const ModalCardTitle = ({
  className = '',
  children = null,
  style = {},
  tag: Tag = 'h5',
  hasTextColor = null,
  hasTextAlign = null,
  isPaddingless = false,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['modal-card-title'];
    
    // Add text color if specified
    if (hasTextColor) {
      classes.push(`has-text-${hasTextColor}`);
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  // Remove custom props that shouldn't be forwarded to DOM
  const { hasTextAlign: _hta, isPaddingless: _ip, ...domProps } = props;

  return (
    <Tag
      className={getClassNames()}
      style={style}
      {...domProps}
    >
      {children}
    </Tag>
  );
};

// eslint-disable-next-line react/require-default-props
ModalCardTitle.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  tag: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object
  ]),
  hasTextColor: PropTypes.string,
};

export default ModalCardTitle;
